// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  padding-right: 1rem;
  padding-left: 1rem;
  margin-right: auto;
  margin-left: auto;
}
@media (max-width: 1200px) {
  .container {
    max-width: 1170px;
  }
}
@media (max-width: 992px) {
  .container {
    max-width: 970px;
  }
}
@media (max-width: 768px) {
  .container {
    max-width: 750px;
  }
}
@media (max-width: 576px) {
  .container {
    max-width: 540px;
  }
}
@media (max-width: 1200px) {
  .container--fluid {
    max-width: inherit;
  }
}
@media (max-width: 992px) {
  .container--fluid {
    max-width: inherit;
  }
}
@media (max-width: 768px) {
  .container--fluid {
    max-width: inherit;
  }
}
@media (max-width: 576px) {
  .container--fluid {
    max-width: inherit;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ui/Container/Container.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AACJ;AACI;EANJ;IAOQ,iBAAA;EAEN;AACF;AAAI;EAVJ;IAWQ,gBAAA;EAGN;AACF;AADI;EAdJ;IAeQ,gBAAA;EAIN;AACF;AAFI;EAlBJ;IAmBQ,gBAAA;EAKN;AACF;AAFQ;EADJ;IAEQ,kBAAA;EAKV;AACF;AAHQ;EALJ;IAMQ,kBAAA;EAMV;AACF;AAJQ;EATJ;IAUQ,kBAAA;EAOV;AACF;AALQ;EAbJ;IAcQ,kBAAA;EAQV;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
